export const parseInboxSearchParams = (searchParams) => {
    const message_id = searchParams.get('message_id') || null;
    const status = searchParams.get('status');

    return { message_id, status };
};
